import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (
    curPageId: string,
    formConfig: FormConfig,
    formValues: FormValues
): Promise<string | undefined> => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'dato';

        case 'dato':
            return 'adresse';

        case 'adresse':
            return 'beskriv-skaden';

        case 'beskriv-skaden':
            return 'skadevolder';

        case 'skadevolder':
            return 'kontatet-haandvaerker';

        case 'kontatet-haandvaerker':
            return 'dokumentation';

        case 'dokumentation':
            return 'andet-selskab';
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            } else {
                return 'om-dig';
            }
        case 'hvilket-selskab':
            return 'om-dig';
        case 'om-dig':
            return 'resume';
        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
